/*
 * Type field of the vehicle pickers (drawer and homepage bar): which product's vehicle list the fields offer.
 * Every product kind has its own fitment index, so a Type switch loads that list, keeps the year, make and model
 * it still offers (SeatFitPickerLists.settle) and sends GO to that product's page. The picker element keeps the
 * state in el.kind, el.index and el.loading; this file only moves it, so the drawer and the bar behave the same.
 * Loaded `defer` after seatfit-vehicle-picker-lists.js and before the picker's own script.
 */
(function () {
  'use strict';
  if (window.SeatFitPickerKind) return;
  var KINDS = ['seat', 'cover', 'mat'];

  function known(kind) { return KINDS.indexOf(kind) >= 0; }

  // The kind the Type field starts on: printed by Liquid (snippets/seatfit-type-options) as data-kind, else the
  // product the page sells, so markup without the attribute still opens on the page's own product.
  function initial(el) {
    var k = el.getAttribute('data-kind');
    var SF = window.SeatFit;
    if (!known(k)) k = SF && SF.kind ? SF.kind() : 'seat';
    return known(k) ? k : 'seat';
  }

  // Type changed: the old list and any request still in flight are dropped; the caller loads the new one.
  function set(el, kind) {
    if (!known(kind) || kind === el.kind) return false;
    el.kind = kind;
    el.index = null;
    el.loading = null;
    return true;
  }

  // Loads the list of el.kind once. hooks {busy(on), failed(on)} drive the spinner and the error line. An answer
  // that lands after Type moved on is thrown away, so a slow first list never replaces the one on screen.
  function load(el, timeoutMs, hooks) {
    if (el.index) return Promise.resolve(el.index);
    if (el.loading) return el.loading;
    var kind = el.kind;
    hooks.failed(false);
    hooks.busy(true);
    var p = window.SeatFitPickerLists.fetchIndex(timeoutMs, kind).then(function (idx) {
      if (el.kind === kind) el.index = idx;
      return idx;
    }, function (e) {
      console.warn('[SeatFit picker] vehicle list failed to load', e);
      if (el.kind === kind) hooks.failed(true);
      return null;
    }).then(function (idx) {
      // A failure can be retried (loading cleared); a success stays in el.index.
      if (el.loading === p) { el.loading = null; hooks.busy(false); }
      return el.kind === kind ? idx : null;
    });
    el.loading = p;
    return p;
  }

  // GO target of a kind: that product's page, from the kinds table of snippets/seatfit-config.liquid.
  function productUrl(kind) {
    var SF = window.SeatFit;
    return SF && SF.kindConfig ? SF.kindConfig(kind).productUrl : '';
  }

  window.SeatFitPickerKind = { KINDS: KINDS, known: known, initial: initial, set: set, load: load, productUrl: productUrl };
})();
